import { z } from 'zod'
import { documentTypeEnum } from '../../schemas/record/documents.schema'

export const GenerateUploadUrlRequest = z.object({
  contractNumber: z.string().min(1),
  documentType: documentTypeEnum,
  fileName: z.string().min(1),
})

export type GenerateUploadUrlRequest = z.infer<typeof GenerateUploadUrlRequest>

export interface UploadUrlResponse {
  uploadUrl: string
  objectKey: string
}

export interface PollDocumentOptions {
  take?: number
}

export interface OfferDocument {
  objectKey: string
  downloadUrl: string
  fileName: string
  lastModified: string
  size: number
}

export interface ListOfferDocumentsResponse {
  documents: OfferDocument[]
}

export const DeleteDocumentRequest = z.object({
  objectKey: z.string().min(1),
})

export type DeleteDocumentRequest = z.infer<typeof DeleteDocumentRequest>

export const ReceiveEndiaDocumentCallbackRequest = z.array(
  z.object({
    data: z.object({
      ErstelltAm: z.coerce.date(),
      Daten: z.object({
        ArchivId: z.string().min(1),
        RueckmeldeInfo5: z.object({
          contractNumber: z.string().min(1),
        }),
      }),
    }),
  })
)

export type ReceiveEndiaDocumentCallbackRequest = z.infer<typeof ReceiveEndiaDocumentCallbackRequest>
